import React, { Component } from 'react';

class TicketPickerCardHeader extends Component {
    render() {
        return(
            <div className="tickets__list">
                <div className="ticket__header">
                    <div className="ticket-header__name" role='heading' aria-level='2'>{this.props.header}</div>
                    <div className="ticket-header__price"></div>
                    <div className="ticket-header__quantity"></div>
                </div>
                {this.props.children}
            </div>
        )
    }
}

export default TicketPickerCardHeader;
